<template>
    <section class="abs" style="top: 0px; right: 0px;">
        <div id="contentMenu">
            <div id="searchInputWrapper" class="flexContainer ai-c jc-sb">
                <input
                    id="searchInput"
                    class="full"
                    type="search"
                    v-model="search"
                    :placeholder="$t('common.search')"
                    @keyup.enter="submit({ search });"
                />
                <div class="ai-c">
                    <img id="cross" src="../../../assets/cross.png" alt="" width="10" height="10" class="cross pointer" @click="reset" />
                </div>
                <div class="ai-c">
                    <router-link :to="{ name: 'Plano', query: getLinkParams({ search }) }">
                        <img id="glass" src="../../../assets/loupe.png" />
                    </router-link>
                </div>
            </div>
            <div id="filtersPlano">
                <ul class="sections flexContainer jc-fs">
                    <router-link
                        exact
                        tag="li"
                        class="rel flexContainer jc-c pointer uppercase iBlock"
                        v-for="(type, index) in types"
                        :key="type.id"
                        :to="{ name: 'Plano', query: getLinkParams({ type: type.id }) }"
                        @click.native="activeSection(index);"
                        :class="{ active: sectionActive === index || type.id === sectionActive }"
                        v-if="type.id === 1 || type.id === 5 || type.id === 7"
                    >
                        <span>{{ type.name }}</span>
                    </router-link>
                    <router-link to="/catalog" tag="a" class="goToCatalogue rel flexContainer jc-c pointer uppercase iBlock" target="_blank">
                        <img src="../../../assets/link_icon.svg" width="15" height="15" class="link" alt="" />{{ $t("plano.gotocatalogue") }}
                    </router-link>
                </ul>
                <ul class="categories">
                    <router-link
                        exact
                        tag="li"
                        class="pointer iBlock"
                        v-for="(cat, index) in categories"
                        :to="{ name: 'Plano', query: getLinkParams({ category: cat.id }) }"
                        @click.native="activeCategories(index);"
                        :key="cat.id"
                        :class="{ active: categoriesActive === index }"
                    >
                        <span class="capitalize">{{ cat.name }}</span>
                    </router-link>
                </ul>
            </div>
            <div id="spinnerLoader" class="flexContainer abs" v-if="loading">
                <Spinner :animation-duration="5000" :size="60" :color="'#41b4e8'" class="loader"></Spinner>
            </div>
            <section id="content">
                <transition-group name="fade" id="resultsWrapper" class="flexContainer fw-w scrollY">
                    <div
                        v-for="(item, index) in getVueResults"
                        :key="item.id"
                        class="item rel size1of3 flexContainer fd-c ai-c jc-fs"
                        :class="itemClass(index)"
                        @mouseover="onHoverProduct(index);"
                        @mouseleave="onHoverLeave(index);"
                        v-if="
                            (item.isConfigured === true && item.type === 'module' && item.is_published === true) ||
                                (item.isConfigured === false && item.type === 'accessory' && item.is_published === true) ||
                                (item.isConfigured === true && item.type === 'structure' && item.is_published === true && item.elementPlano === true)
                        "
                    >
                        <div class="item full center txtCenter">
                            <figure class="rel center">
                                <img
                                    v-if="item.type === 'module'"
                                    :src="getPlanoImg(item)"
                                    :srcmodule="getPathModule(item)"
                                    :srcreal="getPlanoImgReal(item)"
                                    :modulesize="getGridSize(item, '1,1')"
                                    :timestamp="item.timestampModified"
                                    :component_type="item.type"
                                    :id="'item_' + item.id"
                                    @mousedown="copyModule($event, item);"
                                    class="grab img-fluid ff-medium svgMeuble center"
                                />
                                <div
                                    v-if="item.type === 'accessory' && item.subcategories.includes(40)"
                                    :modulesize="getGridSize(item, '1,1')"
                                    :accessory_color="getColorAccessory(item, 'red')"
                                    style="border: 2px solid red; height: 200px;"
                                    :component_subtype="item.subcategories[0]"
                                    :id="'item_' + item.id"
                                    :component_type="item.type"
                                    @mousedown="copyModule($event);"
                                ></div>
                                <div
                                    v-if="item.type === 'accessory' && item.subcategories.includes(31)"
                                    :modulesize="getGridSize(item, '6,1')"
                                    :accessory_color="getColorAccessory(item, 'black')"
                                    style="background-color: #000000; height: 40px;color: #ffffff"
                                    :component_subtype="item.subcategories[0]"
                                    :id="'item_' + item.id"
                                    :component_type="item.type"
                                    @mousedown="copyModule($event, item);"
                                >
                                    {{ getAccessoryName(item) }}
                                </div>
                            </figure>
                            <span v-if="item.infosArticle.hasOwnProperty('diam_ref1')">{{
                                item.infosArticle.diam_ref1.componentProperty.value
                            }}</span>
                            <div class="flexContainer">
                                <h4 class="ff-bold rel capitalize jc-sb center txtCenter">{{ item.terms.name[$t("trad")]["value"] }}</h4>
                                <img src="../../../assets/link_icon.svg" class="pointer" @click="link(item);" height="15" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="flexContainer" id="noResults" key="noResults" v-if="searchResults.length === 0 && noResults">
                        <h3 class="uppercase txtCenter">{{ $t("plano.noresult") }}</h3>
                    </div>
                </transition-group>
            </section>
        </div>
    </section>
</template>
<script>
import { stateMixin } from "../mixins/state";

const pathPlano = "/plano/";
import Globals from "../../globals.js";
import { mapGetters } from "vuex";
import { bus } from "../../../main";

//    import { builderMixin } from '../mixins/builder.js'
import Spinner from "vue-simple-spinner";
//    import { planoMixin } from '../mixins/plano'
//    import { componentMixin } from '../mixins/component'

export default {
    mixins: [stateMixin],
    components: {
        Spinner
    },
    data: () => ({
        rollIndex: null,
        routeParams: {},
        searchResults: [],
        sector: null,
        type: null,
        filterMobile: false,
        switchArrow: null,
        search: "",
        types: {},
        sections: {},
        categories: {},
        to: {},
        from: {},
        sectionActive: null,
        categoriesActive: null,
        subCatActive: null,
        copyItem: false,
        loading: true,
        noResults: false
    }),
    watch: {
        $route(to, from) {
            this.to = to;
            this.from = from;
            if (this._.size(to.query) === 0) {
                this.clearFilters();
            }
            if (this.$route.query.offset === undefined) {
                this.$route.query.offset = 1;
            }
            this.updateQuery(to);
        },
        loading() {}
    },
    methods: {
        copyModule(event, item) {
            bus.$emit("library_copy", event, item);
        },
        getColorAccessory(item, color) {
            if (item.infosArticle.color) {
                color = item.infosArticle.color.componentProperty.value;
            }
            return color;
        },
        getGridSize(item, gridSize) {
            if (item.infosArticle.grid_size) {
                if (item.infosArticle.grid_size.componentProperty.value) {
                    gridSize = item.infosArticle.grid_size.componentProperty.value;
                }
            }
            return gridSize;
        },
        getAccessoryName(item) {
            let name = item.terms.name[this.$t("trad")]["value"];
            name = name.replace("segmentation", "");
            return name;
        },
        link(item) {
            window.open("/" + item.type + "/" + item.id);
        },
        getPlanoImgReal(item) {
            let ret = this._.find(item.figures_advanced, function(o) {
                return o.id_type_file === 5;
            });
            if (typeof ret !== "undefined") {
                return ret.big;
            } else {
                return "";
            }
        },
        activeSection(index) {
            this.sectionActive = index;
        },
        activeCategories(index) {
            if (this.categoriesActive === index) {
                this.categoriesActive = null;
                this.$router.replace(pathPlano + this.$route.params.id + "?type=" + this.sectionActive);
            } else {
                this.categoriesActive = index;
            }
        },
        activeSubCat(index) {
            this.subCatActive = index;
        },
        clearFilters() {
            this._.forEach(this.types, (composant, key) => {
                this.types[key].active = false;
            });
            this._.forEach(this.sections, (section, key) => {
                this.sections[key].active = false;
            });
            this._.forEach(this.categories, (category, key) => {
                this.categories[key].active = false;
                this._.forEach(category.subCategories, (subcategory, scKey) => {
                    this.categories[key].subCategories[scKey].active = false;
                });
            });
            bus.$emit("resetFilters", "");
        },
        reset() {
            this.search = "";
            this.$router.replace(pathPlano + this.$route.params.id + "?type=" + this.sectionActive);
        },
        setVueFiltersSection() {
            let routeParams = this.getRouteParams();
            this._.forEach(this.getFilters("sections"), (section, key) => {
                if (typeof routeParams.section !== "undefined" && parseInt(key) === routeParams.section) {
                    section.active = true;
                } else {
                    section.active = false;
                }
                this.sections[key] = section;
            });
        },
        setVueFiltersType() {
            let routeParams = this.getRouteParams();
            this._.forEach(this.getFilters("types"), (type, key) => {
                if (typeof routeParams.type !== "undefined" && parseInt(key) === parseInt(routeParams.type)) {
                    type.active = true;
                } else {
                    type.active = false;
                }
                this.types[key] = type;
            });
        },
        setVueFiltersCategories() {
            let routeParams = this.getRouteParams();
            if (this._.size(this.categories) === 0) {
                this.categories = this.getFilters("categories");
            }
            this._.forEach(this.categories, (cat, key) => {
                this.categories[key].active = false;
                if (typeof this.getFilters("categories")[key] !== "undefined") {
                    this.categories[key] = this.getFilters("categories")[key];
                } else {
                    this.categories[key].nbItems = 0;
                    this.categories[key].subCategories = {};
                }
            });
            if (typeof routeParams.category !== "undefined") {
                this.categories[routeParams.category].active = true;
            }

            if (typeof routeParams.category !== "undefined") {
                this.categories[routeParams.category].active = true;
            }
            this.$forceUpdate();
        },
        setVueFilters() {
            this.setVueFiltersType();
            this.setVueFiltersSection();
            this.setVueFiltersCategories();
        },
        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },
        getPathModule(item) {
            let ret = this._.find(item.figures_advanced, function(o) {
                return o.id_type_file === 6;
            });

            if (typeof ret !== "undefined") {
                return ret.big;
            } else {
                return "/static/assets/svg/generic_module-01.svg";
            }
        },
        getPlanoImg(item) {
            let ret = this._.find(item.figures_advanced, function(o) {
                return o.id_type_file === 6;
            });
            if (typeof ret !== "undefined") {
                return Globals.getBaseUrl() + ret.big;
            } else {
                return "/static/assets/svg/generic_module-01.svg";
            }
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.$route.query) {
                temp[key] = this.$route.query[key];
            }
            if (x.hasOwnProperty("category")) {
                delete temp.offset;
                delete temp.subcategory;
            } else if (x.hasOwnProperty("type") || x.hasOwnProperty("section")) {
                delete temp.offset;
            }

            for (let key in x) {
                temp[key] = x[key];
            }
            return temp;
        },
        getRouteParams() {
            return this._.omitBy(this.routeParams, (o, key) => {
                return key === "offset" && o === 1;
            });
        },
        setRouteParams(params) {
            let temp = {};
            for (let key in params) {
                if (key !== "url" && key !== "method") {
                    temp[key] = params[key];
                }
            }
            this.routeParams = temp;
        },
        updateQuery(to) {
            this.setRouteParams(to.query);
            this.updateCNBI();
            this.loading = !this.loading;
            this.$store.dispatch("catalog/search/getResults", { routeParams: this.getRouteParams() }).then(() => {
                this.updateVueResults(this.getResults());
                this.loading = false;
                this.noResults = true;
            });
        },
        updateCNBI() {
            this.$store.dispatch("plano/data/populate", { routeParams: this.getRouteParams() }).then(() => {
                this.setVueFilters();
                this.$forceUpdate();
            });
        },
        bordered(index) {
            return (index + 1) % 3 ? "bordered" : "";
        },
        row(index) {
            return index + 1 <= 3 ? "firstRow" : "secondRow";
        },
        hover(index) {
            if (this.rollIndex === index) {
                return "hover-parent";
            }
            if (this.rollIndex === index + 1) {
                return "hover-parent";
            } else {
                return "";
            }
        },
        itemClass(index) {
            return this.bordered(index) + " " + this.row(index) + " " + this.hover(index);
        },
        itemClassMobile(index) {
            return this.borderedMobile(index) + " " + this.rowMobile(index) + " " + this.hover(index);
        },
        onHoverProduct(index) {
            this.rollIndex = index;
        },
        onHoverLeave(index) {
            this.rollIndex = null;
        },
        updateVueResults(datas) {
            this.searchResults = datas;
        },
        showFilters() {
            this.filterMobile = true;
        },
        closeFilters() {
            this.filterMobile = false;
        },
        isActive(object) {
            if (typeof object.offset !== "undefined") {
                let params = this.getRouteParams();
                if (typeof params.offset !== "undefined" && params.offset > 1) {
                    if (parseInt(params.offset) === parseInt(object.offset)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    if (parseInt(object.offset) === 1) {
                        return true;
                    }
                }
            } else {
                return object.active;
            }
        },
        firstLoadToggleActive() {
            this.$store.dispatch("plano/data/populate", { routeParams: this.getRouteParams() }).then(() => {
                this._.forEach(this.categories, (param, key) => {
                    if (typeof this.getFilters("categories")[key] !== "undefined") {
                        this.categories[key].nbItems = this.getFilters("categories")[key].nbItems;
                    } else {
                        this.categories[key].nbItems = 0;
                    }
                });
                this._.forEach(this.getRouteParams(), (param, key) => {
                    if (key === "type") {
                        this.types[param].active = true;
                    }
                    if (key === "category") {
                        this.categories[param].active = true;
                    }
                    if (key === "search") {
                        bus.$emit("updateSearch", this.getRouteParams().search);
                    }
                });
            });
        },
        submit(search) {
            this.$router.push({ name: "Plano", query: this.getLinkParams(search) });
            this.$store.dispatch("catalog/search/setQuery", { search: search }).then(() => {});
        }
    },
    computed: {
        ...mapGetters({
            getBrandColor: "brand/getLinksColor"
        }),
        ...mapGetters("plano/data/", {
            getFilters: "getFilters",
            getFilterName: "getFilterName"
        }),
        ...mapGetters("catalog/search/", {
            getAllResults: "getAllResults",
            getResults: "getResults",
            getResultsLength: "getResultsLength"
        }),
        getVueResults() {
            return this.$data.searchResults;
        }
    },
    created() {
        bus.$on("resetSearch", event => {
            this.clearFilters();
        });
        this.setRouteParams(this.$route.query);
        this.$store.dispatch("plano/data/populate", { routeParams: {} }).then(() => {
            this.loading = !this.loading;
            this.setVueFilters();
            this.$emit("filters_loaded");
            this.loading = false;
        });
        this.$on("filters_loaded", () => {
            this.loading = !this.loading;
            let params = {};
            params.routeParams = {};
            if (this._.size(this.getRouteParams())) {
                params.routeParams = this.getRouteParams();
            }
            this.firstLoadToggleActive();
            this.$store.dispatch("catalog/search/getResults", params).then(() => {
                this.updateVueResults(this.getResults());
                this.loading = false;
            });
        });
        this.$route.query.offset = 1;
        this.sectionActive = 1;
        this.activeSection(1);
    },
    beforeDestroy() {
        bus.$off("resetSearch");
    }
};
</script>
<style lang="scss" scoped>
.goToCatalogue {
    text-decoration: none;
    color: #000;
    margin: auto;
    font-size: 14px;
    border: 1px solid #cfcfcf;
    padding: 10px 15px;
    .link {
        margin-right: 6px;
    }
}

#contentMenu {
    background: #fff;
    height: calc(100vh - 176px);
    #searchInputWrapper {
        padding: 15px;
        #searchInput {
            height: 30px;
            border-left: none;
            border-top: none;
            border-right: none;
            font-size: 14px;
        }
        #cross {
            position: relative;
            right: 15px;
        }
    }
    #filtersPlano {
        padding: 0 15px;
        .sections {
            padding-left: 0;
            margin-top: 0;
            li {
                background-color: #eeeeee;
                padding: 10px 15px;
                font-size: 14px;
                margin-right: 15px;
                &.active {
                    background-color: #41b4e8;
                    color: #fff;
                    &:after {
                        content: "";
                        position: absolute;
                        bottom: -6px;
                        width: 0px;
                        height: 0px;
                        border-left: 7px solid transparent;
                        border-right: 7px solid transparent;
                        border-top: 7px solid #41b4e8;
                    }
                    &:last-child {
                        margin-right: 15px;
                    }
                }
                &.goToCatalogue {
                    background: #fff;
                }
            }
        }
        .categories {
            padding-left: 0;
            margin-top: 20px;
            li {
                padding: 0 10px;
                font-size: 14px;
                color: #aaa;
                &.active {
                    color: #41b4e8;
                }
            }
        }
        .subCategories {
            padding-left: 0;
            margin-top: 15px;
            li {
                padding: 0 10px;
                color: #aaa;
                font-size: 12px;
                &.active {
                    color: #41b4e8;
                }
            }
        }
    }
    #spinnerLoader {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        z-index: 10;
        .loader {
            margin: auto;
        }
    }
    #content {
        height: 100%;
    }
    #noResults {
        height: calc(100vh - 365px);
        h3 {
            margin: auto;
        }
    }
    #resultsWrapper {
        padding: 15px 15px 0px 15px;
        max-height: calc(100vh - 365px);
        .item {
            font-size: 12px;
            margin-bottom: 20px;
            .item {
                margin-bottom: 0;
                img {
                    top: 0;
                    right: 10px;
                }
            }
            &.bordered {
                border-right: 1px solid #ccc;
            }
            .svgMeuble {
                padding: 15px;
                width: 200px;
                height: 200px;
            }
            h3 {
                padding: 0 15px;
                margin: 0;
                a {
                    text-decoration: none;
                    color: #343434;
                }
            }
            figure {
                max-width: 100%;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center center;
            }
        }
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    #contentMenu {
        #filtersPlano {
            .sections {
                li {
                    font-size: 1.1rem;
                    padding: 5px 7px;
                    height: 25px;
                    line-height: 15px;
                    img {
                        width: 10px;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Menu.vue?ebbaee16